import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Series, ValueAxis } from '@progress/kendo-angular-charts';
import {
  CalendarView,
  DateInputsModule,
} from '@progress/kendo-angular-dateinputs';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';

import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import _moment from 'moment';
import { ApiService } from '../service/api.service';

import { Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomainManagerService } from '../service/domain-manager.service';

// const moment = _rollupMoment || _moment;

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class MainComponent implements OnInit {
  public value: Date = new Date();
  seriesData: any[] = [];
  seriesData2: any[] = [];
  seriesData3: any[] = [];
  deviceTypeCategories: string[] = [];
  deviceTypeSeriesData: number[] = [];
  allAdminData: any = [];

  month: any;
  count: any;
  Sort: any;

  p: number = 1;
  total: number = 0;
  clientsCounts: any;
  myForm: any;

  CreatedOn: Date = new Date();
  eventSelectedDt = this.value.getFullYear();

  ctrlValue: any;
  item: any;

  //Chart Format
  public format: FormatSettings = {
    displayFormat: 'yyyy',
    inputFormat: 'yyyy',
  };

  public valueAxes: ValueAxis[] = [
    {
      title: { text: 'Clients' },
      min: 0,
      max: null,
    },
  ];

  public series1: Series[] = [
    {
      data: [this.seriesData],
      stack: true,
      type: 'column',
      color: '#044b4f',
    },
  ];
  public series2: Series[] = [
    {
      data: [this.seriesData2],
      stack: true,
      type: 'column',
      color: '#f9978a',
    },
  ];
  public series3: Series[] = [
    {
      data: [this.seriesData3],
      stack: true,
      type: 'column',
      color: '#779ea0',
    },
  ];

  public categories: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  IsDoctor: boolean = false;
  IsTest: boolean = false;
  isRadiologyDomain: boolean = false;

  public crossingValues: number[] = [0, 0, 10, 10];

  constructor(private readonly _http: ApiService, private readonly domainService: DomainManagerService) { }

  ngOnInit() {
    this.getAllData();
    this.getDeviceTypeCount();
    this.IsTest = this.domainService.isTestDomain;
    this.isRadiologyDomain = this.domainService.isRadiologyDomain;
    this.IsDoctor = false;
    this._http.GetActiveAndNonActiveCountPhysio().subscribe((res: any) => {
      this.clientsCounts = res.Data;
      });
  }

  getDeviceTypeCount() {
    this._http.GetDeviceCount().subscribe((res: any) => {
      if (res?.Success) {
        const deviceCount = res.Data ?? {};
        const deviceTypes = [
          { name: 'Desktop', value: deviceCount.Desktop },
          { name: 'Mobile', value: deviceCount.Mobile },
          { name: 'Tablet', value: deviceCount.Tablet },
          { name: 'Web', value: deviceCount.Web },
          { name: 'Android', value: deviceCount.Android },
          { name: 'iOS', value: deviceCount.Ios },
          { name: 'PWA', value: deviceCount.PWA },
        ];

        this.deviceTypeCategories = deviceTypes.map((device) => device.name);
        this.deviceTypeSeriesData = deviceTypes.map((device) => device.value ?? 0);
      }
    });
  }

  getAllData() {
    let selectedYear = this.eventSelectedDt;
    this._http
      .getAppointmentAndPatentCountByMonth(selectedYear)
      .subscribe((res: any) => {
        this.allAdminData = res.Data;

        let maxVal = 0; // initialize max value to zero
        // loop through all objects in the array
        if (!!this.allAdminData) {
          for (let index = 0; index < this.allAdminData.length; index++) {
            this.categories.forEach((prop) => {
              if (this.allAdminData[index][prop] > maxVal) {
                maxVal = this.allAdminData[index][prop];
              }
            });
          }
        }


        maxVal = Math.ceil(maxVal / 1000) * 1000;


        let dynamicvalue = maxVal + 1000
        if (maxVal > dynamicvalue) {
          var temp = maxVal.toString().length;
          var counter = 1;
          for (let index = 0; index < temp - 1; index++) {
            counter = counter * (10);
          }
          maxVal = maxVal + counter;
          this.valueAxes.find((t) => (t.max = maxVal));
        }


        // var temp = maxVal.toString().length;
        // var counter = 1;
        // for (let index = 0; index < temp-1; index++) {
        //   counter = counter * (10);
        // }
        // maxVal = maxVal + counter;
        // this.valueAxes.find((t) => (t.max = maxVal));





        this.seriesData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.seriesData2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.seriesData3 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];



        if (this.allAdminData) {
          for (let i = 0; i < this.allAdminData.length; i++) {
            let selectedYear = this.eventSelectedDt;
            let year = this.allAdminData[i].Year;
            if (selectedYear.toString() == year.toString()) {
              if (this.allAdminData[i].Jan > 0) {
                if (i == 0)
                  this.seriesData[0] =
                    this.seriesData[0] + this.allAdminData[i].Jan;
                if (i == 1)
                  this.seriesData2[0] =
                    this.seriesData2[0] + this.allAdminData[i].Jan;
                if (i == 2)
                  this.seriesData3[0] =
                    this.seriesData3[0] + this.allAdminData[i].Jan;
              }
              if (this.allAdminData[i].Feb > 0) {
                if (i == 0)
                  this.seriesData[1] =
                    this.seriesData[1] + this.allAdminData[i].Feb;
                if (i == 1)
                  this.seriesData2[1] =
                    this.seriesData2[1] + this.allAdminData[i].Feb;
                if (i == 2)
                  this.seriesData3[1] =
                    this.seriesData3[1] + this.allAdminData[i].Feb;
              }
              if (this.allAdminData[i].Mar > 0) {
                if (i == 0)
                  this.seriesData[2] =
                    this.seriesData[2] + this.allAdminData[i].Mar;
                if (i == 1)
                  this.seriesData2[2] =
                    this.seriesData2[2] + this.allAdminData[i].Mar;
                if (i == 2)
                  this.seriesData3[2] =
                    this.seriesData3[2] + this.allAdminData[i].Mar;
              }
              if (this.allAdminData[i].Apr > 0) {
                if (i == 0)
                  this.seriesData[3] =
                    this.seriesData[3] + this.allAdminData[i].Apr;
                if (i == 1)
                  this.seriesData2[3] =
                    this.seriesData2[3] + this.allAdminData[i].Apr;
                if (i == 2)
                  this.seriesData3[3] =
                    this.seriesData3[3] + this.allAdminData[i].Apr;
              }
              if (this.allAdminData[i].May > 0) {
                if (i == 0)
                  this.seriesData[4] =
                    this.seriesData[4] + this.allAdminData[i].May;
                if (i == 1)
                  this.seriesData2[4] =
                    this.seriesData2[4] + this.allAdminData[i].May;
                if (i == 2)
                  this.seriesData3[4] =
                    this.seriesData3[4] + this.allAdminData[i].May;
              }
              if (this.allAdminData[i].Jun > 0) {
                if (i == 0)
                  this.seriesData[5] =
                    this.seriesData[5] + this.allAdminData[i].Jun;
                if (i == 1)
                  this.seriesData2[5] =
                    this.seriesData2[5] + this.allAdminData[i].Jun;
                if (i == 2)
                  this.seriesData3[5] =
                    this.seriesData3[5] + this.allAdminData[i].Jun;
              }
              if (this.allAdminData[i].Jul > 0) {
                if (i == 0)
                  this.seriesData[6] =
                    this.seriesData[6] + this.allAdminData[i].Jul;
                if (i == 1)
                  this.seriesData2[6] =
                    this.seriesData2[6] + this.allAdminData[i].Jul;
                if (i == 2)
                  this.seriesData3[6] =
                    this.seriesData3[6] + this.allAdminData[i].Jul;
              }
              if (this.allAdminData[i].Aug > 0) {
                if (i == 0)
                  this.seriesData[7] =
                    this.seriesData[7] + this.allAdminData[i].Aug;
                if (i == 1)
                  this.seriesData2[7] =
                    this.seriesData2[7] + this.allAdminData[i].Aug;
                if (i == 2)
                  this.seriesData3[7] =
                    this.seriesData3[7] + this.allAdminData[i].Aug;
              }
              if (this.allAdminData[i].Sep > 0) {
                if (i == 0)
                  this.seriesData[8] =
                    this.seriesData[8] + this.allAdminData[i].Sep;
                if (i == 1)
                  this.seriesData2[8] =
                    this.seriesData2[8] + this.allAdminData[i].Sep;
                if (i == 2)
                  this.seriesData3[8] =
                    this.seriesData3[8] + this.allAdminData[i].Sep;
              }
              if (this.allAdminData[i].Oct > 0) {
                if (i == 0)
                  this.seriesData[9] =
                    this.seriesData[9] + this.allAdminData[i].Oct;
                if (i == 1)
                  this.seriesData2[9] =
                    this.seriesData2[9] + this.allAdminData[i].Oct;
                if (i == 2)
                  this.seriesData3[9] =
                    this.seriesData3[9] + this.allAdminData[i].Oct;
              }
              if (this.allAdminData[i].Nov > 0) {
                if (i == 0)
                  this.seriesData[10] =
                    this.seriesData[10] + this.allAdminData[i].Nov;
                if (i == 1)
                  this.seriesData2[10] =
                    this.seriesData2[10] + this.allAdminData[i].Nov;
                if (i == 2)
                  this.seriesData3[10] =
                    this.seriesData3[10] + this.allAdminData[i].Nov;
              }
              if (this.allAdminData[i].Dec > 0) {
                if (i == 0)
                  this.seriesData[11] =
                    this.seriesData[11] + this.allAdminData[i].Dec;
                if (i == 1)
                  this.seriesData2[11] =
                    this.seriesData2[11] + this.allAdminData[i].Dec;
                if (i == 2)
                  this.seriesData3[11] =
                    this.seriesData3[11] + this.allAdminData[i].Dec;
              }
            }
          }

          this.Sort = this.allAdminData.sort().reverse((Id: any) => Id);
        }

      });

  }

  pageChangeEvent(event: number) {
    this.p = event;
    this.getAllData();
  }
  //Mat-datepicker year Start Here
  date = new FormControl(moment());
  chosenYearHandler(normalizedYear: Moment, dp: any) {
    let ctrlValue: any = null;
    ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    dp.close();
    this.eventSelectedDt = ctrlValue._d.getFullYear();
    this.getAllData();
  }

  //End Here
}
